import './style.scss'
import { Media } from '../../../js/utils/const'
import { request, Timeout } from '../../../js/utils/http'
import { createVideoPlayback } from '../../../js/utils/video-playback'
import { Slider } from '../../../js/components/Slider/Slider'
import { DetailsModal } from '../../../js/components/DetailsModal/DetailsModal'
import { MentorModal } from './MentorModal/MentorModal'

export default !function () {
  const block = document.querySelector('.mentor-v3')

  if (!block) {
    return
  }

  const blockName = block.dataset.blockName ?? 'Блок без названия'

  // Полифилл, так как хром не умеет в медиа-запросы в source для video
  const video = block.querySelector('.mentor-v3__media--video')

  if (video) {
    video.removeAttribute('autoplay')
    const { play, pause } = createVideoPlayback(video)
    const videoSources = video.querySelectorAll('source')

    const sources = {
      mobile: {
        webm: videoSources[0].src,
        mp4: videoSources[1].src
      },
      desktop: {
        webm: video.dataset.srcWebm,
        mp4: video.dataset.srcMp4
      }
    }

    const createSource = (viewport, format) => {
      const src = sources[viewport][format]

      if (src) {
        const source = document.createElement('source')
        source.src = src
        source.type = `video/${format}`

        video.appendChild(source)
      }
    }

    const switchSources = (viewport) => {
      const formats = ['webm', 'mp4']
      const hasViewportSrc = formats.some(format => sources[viewport][format])

      if (hasViewportSrc) {
        pause()

        video.innerHTML = ''

        formats.forEach(format => {
          createSource(viewport, format)
        })

        video.load()
        play()
      }
    }

    const desktop = window.matchMedia('(min-width: 1024px)')

    const desktopMediaChangeListener = () => {
      if (desktop.matches) {
        switchSources('desktop')
      } else {
        switchSources('mobile')
      }
    }

    desktopMediaChangeListener()
    desktop.addEventListener('change', desktopMediaChangeListener)
  }

  // Detailed view
  let mediaData = []
  const button = block.querySelector('.mentor-v3__button')

  const setDisabled = (button, isDisabled) => {
    button.disabled = isDisabled
    isDisabled
      ? button.classList.add('ui-button--loading')
      : button.classList.remove('ui-button--loading')
  }

  const buttonClickHandler = async (evt) => {
    const button = evt.target.closest('.mentor-v3__button')

    setDisabled(button, true)

    try {
      if (!mediaData.length) {
        // eslint-disable-next-line
        const response = await request(`/landgen/api/v1/landing/${landingInfo.landing_ID}/country/${landingInfo.countrySlug}/language/${landingInfo.languageSlug}/media-gallery?block_slug=${block.id}`, { timeout: Timeout.REFERENCE })

        if (!response.ok) {
          await Promise.reject(response)
        }

        mediaData = await response.json()
      }

      mediaData.length && new DetailsModal(mediaData, 0, blockName).init()
    } catch (e) {
      e.message = `[media-gallery] ${e.message}`
      window.Sentry.captureException(e)
    } finally {
      setDisabled(button, false)
    }

    window.$analytics?.push('mentor-click-details')
  }

  button?.addEventListener('click', buttonClickHandler)

  // slider
  const sliderContainer = block.querySelector('.mentor-v3__top')

  if (!sliderContainer) {
    return
  }

  const slides = sliderContainer.querySelectorAll('.mentor-v3__card')

  const isInitMobile = slides.length > 1
  const isInitTablet = slides.length > 2

  const options = {
    wrapper: sliderContainer,
    settings: {
      loop: false,
      slideClass: 'mentor-v3__card',
      wrapperClass: 'mentor-v3__cards',
    },
    modules: ['a11y'],
    initCondition: {
      sm: isInitMobile,
      md: isInitTablet,
      lg: false,
      xl: false
    }
  }

  new Slider(options).init()

  // ShowDetailsModal
  const mdMax = window.matchMedia(`(max-width: ${Media.MD_MAX}px)`)
  const cardList = block.querySelector('.mentor-v3__cards')
  const cards = [...cardList.querySelectorAll('.mentor-card-details')]
  let mentorModal = null
  let timeout = null

  const cardsClickHandler = (evt) => {
    const card = evt.target.closest('.mentor-v3__card')

    if (card) {
      const currentDetails = card.querySelector('.mentor-card-details')
      const cardNumber = cards.indexOf(currentDetails)

      mentorModal = new MentorModal(cards, cardNumber + 1, blockName)
      mentorModal.init()
    }
  }

  const localClearTimeout = () => {
    clearInterval(timeout)
    timeout = null
  }

  const cardMouseEnterHandler = (evt) => {
    if (timeout !== null) {
      localClearTimeout()
    }

    timeout = setInterval(() => {
      const card = evt.target.closest('.mentor-card')
      const index = [...cardList.children].indexOf(card)

      window.$analytics?.push('mentor-shown-card', { id: index + 1 })
      localClearTimeout()
    }, 5000)
  }

  const cardMouseLeaveHandler = () => {
    localClearTimeout()
  }

  const tabletMediaChangeListener = () => {
    if (mdMax.matches) {
      cardList.addEventListener('click', cardsClickHandler)

      cards.forEach((card) => {
        card.removeEventListener('mouseenter', cardMouseEnterHandler)
        card.removeEventListener('mouseleave', cardMouseLeaveHandler)
      })
    } else {
      mentorModal?.close()
      cardList.removeEventListener('click', cardsClickHandler)

      cards.forEach((card) => {
        card.addEventListener('mouseenter', cardMouseEnterHandler)
        card.addEventListener('mouseleave', cardMouseLeaveHandler)
      })
    }
  }

  tabletMediaChangeListener()

  const cardTitles = document.querySelectorAll('.mentor-card-details__title')

  const changeTitlesClass = () => {
    const removeClass = mdMax.matches ? ['t', 't--4'] : ['h', 'h--4']
    const addClass = mdMax.matches ? ['h', 'h--4'] : ['t', 't--4']

    cardTitles.forEach(title => {
      title.classList.remove(...removeClass)
      title.classList.add(...addClass)
    });
  }
  changeTitlesClass ()

  mdMax.addEventListener('change', (event) => {
    tabletMediaChangeListener(event)
    changeTitlesClass(event)
  });
}()
